export const CLEAR_SHIFT = "CLEAR_SHIFT"
export const ADD_NEW_SHIFT_ORDER = "ADD_NEW_SHIFT_ORDER"
export const ADD_PAID_OUT = "ADD_PAID_OUT"
export const ADD_PAID_IN = "ADD_PAID_IN"
export const OPEN_SHIFT = "OPEN_SHIFT"
export const ADD_REFUND = "ADD_REFUND"
export const INCREASE_SHIFT_QUEUE_NUMBER = "INCREASE_SHIFT_QUEUE_NUMBER"
export const UPDATE_SHIFT_QUEUE_NUMBERS = "UPDATE_SHIFT_QUEUE_NUMBERS"